import { Injectable } from '@angular/core';
import { UserSessionService } from 'bna-angular-auth-client';
@Injectable({
  providedIn: 'root',
})
export class UserGroupService {
  constructor(public userSessionService: UserSessionService) {}

  isUserOrgAdmin() {
    const userClaims = this.userSessionService.getProfile();
    return userClaims['userGroup']?.includes('OrganizationAdmins')
      ? true
      : false;
  }
  isUserPropertyManagerOnly() {
    const userClaims = this.userSessionService.getProfile();
    return userClaims['userGroup']?.includes('PropertyManagers') &&
      !this.isUserOrgAdmin()
      ? true
      : false;
  }
  isUserLeadOrgAdmin() {
    const userClaims = this.userSessionService.getProfile();
    return userClaims['userGroup']?.includes('LeadOrganizationAdmins')
      ? true
      : false;
  }
  getProfile() {
    return this.userSessionService.getProfile();
  }
}
